import i18next from 'i18next';

export default function translateError(path) {
  return i18next.t(path);
}
